import React, { useEffect, useState, ChangeEvent, useRef, useMemo } from "react";
import {
    TextField, Grid, MenuItem, Select, Button, IconButton, Typography, Box, Stack, Modal,
    Divider, CircularProgress, Paper, Radio, Skeleton, Chip,
    Menu, ListItemIcon,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';

import { useNavigate, useLocation } from "react-router-dom";
import RohanImg from '../../../assets/podcast_monster/rohan_png.png';
import ocesha_logo from '../../../assets/ocesha_images/ocesha_logo.png';
import AIConciergePopup from '../../../components/AIConciergePopup';
import { toast } from "react-toastify";
import axios from 'axios';
import ProgressBar from "@ramonak/react-progress-bar";

import { setCookie, getCookie, removeCookie } from '../../../utils/storageUtils';
import { useAppDispatch } from '../../../redux/store';
import { logout } from "redux/features/userSlice";
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import { usePlanDetailsMutation } from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { isMobile } from "react-device-detect";

import '../generated_blogs.css';
import './CreateCourse.module.css';

// ─────────────────────────────────────────────────────────────────────────────
// SIDEBAR NAV CONFIG
// ─────────────────────────────────────────────────────────────────────────────
const sidebarItems = [
    { id: "authority", label: "Dashboard",   icon: <AutoGraphOutlinedIcon sx={{ fontSize: 18 }} /> },
    { id: "mycourse",  label: "My Course",   icon: <SchoolOutlinedIcon    sx={{ fontSize: 18 }} /> },
];

const contentLibraryItems = [
    { id: "blogs",    label: "Blogs",        icon: <ArticleOutlinedIcon           sx={{ fontSize: 16 }} /> },
    { id: "episodes", label: "Episodes",     icon: <GraphicEqIcon                 sx={{ fontSize: 16 }} /> },
    { id: "clips",    label: "Clips",        icon: <PlayCircleOutlinedIcon        sx={{ fontSize: 16 }} /> },
    { id: "images",   label: "Images",       icon: <ImageOutlinedIcon             sx={{ fontSize: 16 }} /> },
    { id: "social",   label: "Social Posts", icon: <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 16 }} /> },
];

const bottomNav = [
    { id: "upgrade",   label: "Upgrade",         icon: <TrendingUpOutlinedIcon  sx={{ fontSize: 18 }} /> },
    { id: "payment",   label: "Connect Stripe",  icon: <PaymentOutlinedIcon     sx={{ fontSize: 18 }} /> },
    { id: "messages",  label: "Messages & Leads",icon: <PersonOutlineOutlinedIcon sx={{ fontSize: 18 }} /> },
    { id: "profile",   label: "Authority Page",  icon: <PersonOutlineOutlinedIcon sx={{ fontSize: 18 }} /> },
    { id: "analytics", label: "Analytics",       icon: <TrendingUpIcon          sx={{ fontSize: 18 }} /> },
    { id: "logout",    label: "Logout",          icon: <LogoutOutlinedIcon      sx={{ fontSize: 18 }} /> },
];

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const Course_Suggestions = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();


    const { FromEdit, campIdFrEdit } = location.state || {};
    const FromSignUp = location.state?.FromSignUp || '';

    const apiUrl    = process.env.REACT_APP_SERVER_ENDPOINT || "";
    const user_email = localStorage.getItem('user_email') || getCookie('user_email') || '';
    const userEmail  = user_email;
    const courseId   = localStorage.getItem("course_id") || "";

    // ── Plan/campaign state ──
    const [planDetails, setPlanDetails]     = useState<any>();
    const [userDetails, setUserDetails]     = useState<any>();

    // ── UI state ──
    const [isloadingGetPage, setIsLoadingGetPage] = useState<boolean>(false);
    const [loaderProgress, setLoaderProgress]     = useState<any>(4);
    const [loadingText, setLoadingText]           = useState<any>(
        <Typography fontSize="18px">
            <b>Loading Course Suggestions</b><br />
            We're using AI Agents to suggest the best course topics for your expertise.
        </Typography>
    );
    const [getPageError, setGetPageError]     = useState(false);
    const [upgradeModal, setUpgradeModal]     = useState<boolean>(false);
    const [helperPopup, setHelperPopup]       = useState<boolean>(false);
    const [helpervideosrc, setHelperVideoSrc] = useState<any>();
    const [openpaymentInstructModal, setOpenPaymentInstructModal] = useState<boolean>(false);

    // ── Course suggestion state ──
    const [COURSE_OPTIONS, setCOURSE_OPTIONS] = useState<any[]>([]);
    const [loadingtopics, setLoadingTopics]   = useState<boolean>(false);
    const [savingtopicIndex, setSavingTopicIndex] = useState<any>(null);
    const [selectedCourses, setSelectedCourses] = useState<string[]>([]);

    // ── Sidebar/menu state ──
    const [activeItem, setActiveItem]       = useState(localStorage.getItem('activeItem') || 'createcourse');
    const [contentLibOpen, setContentLibOpen] = useState(true);
    const [openAIConcierge, setOpenAIConcierge] = useState(false);

    // ── Profile dropdown ──
    const [profileMenuAnchor, setProfileMenuAnchor] = useState<null | HTMLElement>(null);
    const isProfileMenuOpen = Boolean(profileMenuAnchor);

    // ── Refs ──
    const triggerFetchedRef = useRef(false);

    // ── RTK mutations ──
    const [getUserDetailsMutation] = useGetUserDetailsMutation();
    const [getuserPlanDetails]     = usePlanDetailsMutation();
    const [campaignListMutation]   = useCampaignListMutation();

    // ─────────────────────────────────────────────────────────────────────
    // POLLING — task_status endpoint
    // ─────────────────────────────────────────────────────────────────────
    interface TaskStatusResponse {
        state: "pending" | "done" | "error" | "failed";
        result?: any;
        message?: string;
    }

    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    const waitForTaskResult = async (taskId: string): Promise<any> => {
        const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;
        let attempts = 0;
        const MAX_ATTEMPTS = 60;

        while (attempts < MAX_ATTEMPTS) {
            attempts++;
            try {
                const { data } = await axios.get<TaskStatusResponse>(statusUrl);
                if (data.state === "done") return data.result;
                if (data.state === "error" || data.state === "failed") {
                    throw new Error(data.message || "Task failed");
                }
            } catch (err) {
                console.error("[CourseTopics] polling error:", err);
            }
            await sleep(3000);
        }
        throw new Error("Timeout waiting for course topic suggestions");
    };

    // ─────────────────────────────────────────────────────────────────────
    // Fetch course topic suggestions via trigger+poll
    // ─────────────────────────────────────────────────────────────────────
    const fetchCourseTopicSuggestions = async () => {
        if (loadingtopics) return;
        if (!userEmail) return;

        try {
            setLoadingTopics(true);

            const triggerRes = await axios.post(
                    `${apiUrl}/api/prompts/process_create_courses_topics_suggestions_trigger?user_email=${encodeURIComponent(userEmail)}`,
                    "",
                    {
                        headers: {
                            "Content-Type": "application/json",
                            accept:         "application/json",
                        },
                    }
            );

            const taskId = triggerRes.data?.task_id;
            if (!taskId) {
                console.warn("[CourseTopics] no task_id in trigger response");
                toast.error("Could not start course topic generation. Please try again.");
                return;
            }

            const result = await waitForTaskResult(taskId);
            console.log("[CourseTopics] task result:", result);

            const list = result?.courses || [];

            if (!Array.isArray(list) || list.length === 0) {
                console.warn("[CourseTopics] no courses in response");
                toast.error("No topics generated. Please try again.");
                return;
            }

            if (result?.course_id) {
                localStorage.setItem("course_id", result.course_id);
            }

            setCOURSE_OPTIONS(list);
        } catch (err) {
            console.error("[CourseTopics] fetch failed:", err);
            toast.error("No topics generated. Please try again.");
        } finally {
            setLoadingTopics(false);
        }
    };

    // ─────────────────────────────────────────────────────────────────────
    // Save selected course
    // ─────────────────────────────────────────────────────────────────────
    const toggleCourse = async (courseNumber: any) => {
        if (savingtopicIndex === courseNumber) return;
        if (selectedCourses[0] === courseNumber) return;

        const course = COURSE_OPTIONS.find((c: any) => c.course_number === courseNumber);
        if (!course) return;

        const parentCourseId = localStorage.getItem("course_id") || "";

        try {
            setSavingTopicIndex(courseNumber);

            await axios.post(`${apiUrl}/api/prompts/save-course`, {
                parent_course_id:  parentCourseId,
                title:             course.title || course.name,
                name:              course.name,
                description:       course.description,
                difficulty:        course.difficulty || "beginner",
                target_audience:   course.target_audience,
                suggested_price:   Number(String(course.pricing || "").replace(/[^\d]/g, "")),
                user_email:        userEmail,
                duration:          course.duration,
                learning_outcomes: course.learning_outcomes,
                curriculum:        course.curriculum,
            });

            toast.success("Topic selected");
            setSelectedCourses([course.course_number]);
        } catch (error: any) {
            console.log('[CourseTopics] save failed:', error);
            toast.error("Could not save selection. Please try again.");
        } finally {
            setSavingTopicIndex(null);
        }
    };

    const isCourseSelected = selectedCourses.length > 0;

    const handleCourseChange = (index: number, field: string, value: string) => {
        setCOURSE_OPTIONS(prev =>
            prev.map((c, i) => i === index ? { ...c, [field]: value } : c)
        );
    };

    // ─────────────────────────────────────────────────────────────────────
    // Lifecycle
    // ─────────────────────────────────────────────────────────────────────
    const fetchUserData = async () => {
        try {
            const response = await getUserDetailsMutation({
                email: user_email || getCookie('user_email') || '',
                filter: '', start_date: '', end_date: ''
            });
            if ('data' in response) setUserDetails(response.data.data);
        } catch (error) { console.log(error); }
    };

    const fetchPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({
                email: user_email || getCookie('user_email') || '', campaignid: ''
            });
            if ('data' in response) setPlanDetails(response.data.data);
        } catch (error) { console.log(error); }
    };

    useEffect(() => {
        fetchUserData();
        fetchPlanDatas();
    }, []);

    useEffect(() => {
        if (triggerFetchedRef.current) return;
        triggerFetchedRef.current = true;
        fetchCourseTopicSuggestions();
    }, [userEmail]);

    // ─────────────────────────────────────────────────────────────────────
    // Navigation
    // ─────────────────────────────────────────────────────────────────────
    const handleCreateCourseStep2 = () => {
        const nextpage = localStorage.getItem("nextpage");
        if (nextpage === "createcourse3") {
            localStorage.setItem("activeItem", "createcourse3");
            navigate("/codegenie/generated-blogs",
                { state: { FromSignUp: FromSignUp === "true" ? FromSignUp : "" } });
            setTimeout(() => window.location.reload(), 100);
        } else {
            navigate("/codegenie/new-course-3",
                { state: { FromSignUp: FromSignUp === "true" ? FromSignUp : "" } });
        }
    };

    const handleCreateCourseStepPrevious = () => {
        navigate('/codegenie/new-course',
            { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });
    };

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const handleItemClick = (itemName: any) => {
        setActiveItem(itemName);

        if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            dispatch(logout());
            toast.success("Logout success");
            localStorage.clear();
            removeCookie('user_email');
            window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN||''; //"https://ocesha.ai";
            return;
        }

        if (itemName === 'upgrade') {
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { from_page: 'blog_listing' } });
            return;
        }

        if (itemName === 'createcourse') {
            localStorage.setItem('activeItem', 'createcourse');
            navigate('/codegenie/new-course-2-1');
            return;
        }

        if (itemName === 'mycourse') {
            localStorage.setItem('activeItem', 'course');
            navigate('/codegenie/generated-courses');
            return;
        }

        // All panels live inside ocesha_new_design at /codegenie/generated-blogs
        // including authority (Dashboard) and payment (Connect Stripe)
        const panelMap: Record<string, string> = {
            authority:   'authority',
            dashboard:   'authority',    // Dashboard = authority panel
            blogs:       'blogs',
            episodes:    'episodes',
            clips:       'clips',
            images:      'images',
            social:      'socailpost',   // ocesha_new_design key
            digitaltwin: 'digital',      // ocesha_new_design key
            messages:    'message',      // ocesha_new_design key
            profile:     'profile',
            analytics:   'analytics',
            settings:    'settings',
            billing:     'billing',
            payment:     'payment',      // Connect Stripe — also a panel
        };

        const panelKey = panelMap[itemName] ?? itemName;
        localStorage.setItem('activeItem', panelKey);
        navigate('/codegenie/generated-blogs', { state: { activeItem: panelKey } });
    };

    // ─────────────────────────────────────────────────────────────────────
    // RENDER
    // ─────────────────────────────────────────────────────────────────────
    return (
        <>
        <Box sx={{
            display: "flex",
            minHeight: "100vh",
            background: "#000000",
            color: "#fff",
            fontFamily: "'Inter', -apple-system, sans-serif",
        }}>

            {/* ═══════════════ SIDEBAR ═══════════════ */}
            <Box sx={{
                width: 260,
                flexShrink: 0,
                background: "linear-gradient(180deg, #0B1220 0%, #06080F 100%)",
                borderRight: "1px solid rgba(255,255,255,0.06)",
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                position: "sticky", top: 0,
                height: "100vh", overflowY: "auto",
            }}>

                {/* Logo */}
                <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2.5, pt: 2.5, pb: 2 }}>
                    <Box
                        component="a"
                        href={process.env.REACT_APP_LOGOUT_DOMAIN || "https://ocesha.ai"}
                        sx={{ display: "inline-flex", alignItems: "center", flex: 1, minWidth: 0 }}
                    >
                        <Box
                            component="img"
                            src={ocesha_logo}
                            alt="Ocesha"
                            sx={{ height: 32, width: "auto", maxWidth: "100%", objectFit: "contain", display: "block" }}
                        />
                    </Box>
                    <YouTubeIcon sx={{ color: "#FF0000", fontSize: 22, flexShrink: 0, cursor: "pointer" }} />
                </Stack>

                {/* AI Digital Twin card */}
                <Box sx={{
                    mx: 2, mb: 2, p: 1.5, borderRadius: "12px",
                    background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
                    border: "1px solid rgba(255,255,255,0.06)",
                    cursor: "pointer",
                }}
                onClick={() => setOpenAIConcierge(true)}
                >
                    <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.45)", letterSpacing: 1, fontWeight: 600, mb: 1 }}>
                        AI Concierge
                    </Typography>
                    <Stack direction="row" spacing={1.2} alignItems="center" mb={1.5}>
                        <Box component="img" src={userDetails?.profile_image || RohanImg} sx={{
                            width: 36, height: 36, borderRadius: "50%", objectFit: "cover",
                        }} />
                        <Box>
                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
                                AI Concierge Online
                            </Typography>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E" }} />
                                <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>
                                    AI Twin Online
                                </Typography>
                            </Stack>
                        </Box>
                    </Stack>
                    <Stack direction="row" alignItems="center"
                        sx={{
                            background: "rgba(255,255,255,0.04)",
                            border: "1px solid rgba(255,255,255,0.06)",
                            borderRadius: "8px", px: 1.2, py: 0.6,
                            cursor: "pointer",
                            "&:hover": { background: "rgba(255,255,255,0.07)" },
                        }}>
                        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", flex: 1 }}>
                            Ask AI Concierge
                        </Typography>
                        <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.5)" }} />
                    </Stack>
                </Box>

                {/* Main nav */}
                <Stack spacing={0.4} sx={{ px: 1.5 }}>
                    {sidebarItems.map((item) => {
                        const active = activeItem === item.id;
                        return (
                            <Stack key={item.id} direction="row" spacing={1.2} alignItems="center"
                                onClick={() => handleItemClick(item.id)}
                                sx={{
                                    cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                                    background: active ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
                                    color: active ? "#fff" : "rgba(255,255,255,0.7)",
                                    "&:hover": { background: active ? undefined : "rgba(255,255,255,0.04)" },
                                }}>
                                {item.icon}
                                <Typography sx={{ fontSize: 13.5, fontWeight: active ? 600 : 500 }}>
                                    {item.label}
                                </Typography>
                            </Stack>
                        );
                    })}

                    {/* Content Library */}
                    <Box>
                        <Stack direction="row" spacing={1.2} alignItems="center"
                            onClick={() => setContentLibOpen((v) => !v)}
                            sx={{
                                cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                                color: "rgba(255,255,255,0.7)",
                                "&:hover": { background: "rgba(255,255,255,0.04)" },
                            }}>
                            <FolderOutlinedIcon sx={{ fontSize: 18 }} />
                            <Typography sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
                                Content Library
                            </Typography>
                            {contentLibOpen ? <KeyboardArrowUpIcon sx={{ fontSize: 16 }} /> : <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
                        </Stack>

                        {contentLibOpen && (
                            <Stack spacing={0.3} sx={{ ml: 3, mt: 0.3 }}>
                                {contentLibraryItems.map((item) => {
                                    const active = activeItem === item.id;
                                    return (
                                        <Stack key={item.id} direction="row" spacing={1} alignItems="center"
                                            onClick={() => handleItemClick(item.id)}
                                            sx={{
                                                cursor: "pointer", px: 1.2, py: 0.7, borderRadius: "7px",
                                                color: active ? "#4BA5EB" : "rgba(255,255,255,0.6)",
                                                background: active ? "rgba(75,165,235,0.08)" : "transparent",
                                                "&:hover": { background: "rgba(255,255,255,0.03)" },
                                            }}>
                                            {item.icon}
                                            <Typography sx={{ fontSize: 12.5 }}>{item.label}</Typography>
                                        </Stack>
                                    );
                                })}
                            </Stack>
                        )}
                    </Box>

                    <Stack direction="row" spacing={1.2} alignItems="center"
                        onClick={() => handleItemClick("digitaltwin")}
                        sx={{
                            cursor: "pointer", px: 1.5, py: 1, mt: 0.4, borderRadius: "8px",
                            color: activeItem === "digitaltwin" ? "#4BA5EB" : "rgba(255,255,255,0.7)",
                            background: activeItem === "digitaltwin" ? "rgba(75,165,235,0.08)" : "transparent",
                            "&:hover": { background: "rgba(255,255,255,0.04)" },
                        }}>
                        <SmartToyOutlinedIcon sx={{ fontSize: 18 }} />
                        <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>My Digital Twin</Typography>
                    </Stack>
                </Stack>

                <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", my: 2, mx: 2 }} />

                {/* Bottom nav */}
                <Stack spacing={0.4} sx={{ px: 1.5, pb: 2 }}>
                    {bottomNav.map((item) => (
                        <Stack key={item.id} direction="row" spacing={1.2} alignItems="center"
                            onClick={() => handleItemClick(item.id)}
                            sx={{
                                cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                                color: "rgba(255,255,255,0.65)",
                                "&:hover": { background: "rgba(255,255,255,0.04)" },
                            }}>
                            {item.icon}
                            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>{item.label}</Typography>
                        </Stack>
                    ))}
                </Stack>
            </Box>

            {/* ═══════════════ MAIN CONTENT ═══════════════ */}
            <Box sx={{ flex: 1, overflowY: "auto" }}>

                {/* TOP HEADER BAR */}
                <Stack direction="row" alignItems="center" justifyContent="flex-end"
                    sx={{
                        px: { xs: 2, md: 3 }, py: 1.5,
                        borderBottom: "1px solid rgba(255,255,255,0.06)",
                        background: "rgba(0,0,0,0.4)",
                        position: "sticky", top: 0, zIndex: 10,
                        backdropFilter: "blur(10px)",
                    }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <IconButton sx={{ position: "relative", color: "rgba(255,255,255,0.7)" }}>
                            <NotificationsNoneOutlinedIcon sx={{ fontSize: 22 }} />
                            <Box sx={{
                                position: "absolute", top: 6, right: 6,
                                width: 18, height: 18, borderRadius: "50%",
                                background: "#EF4444", color: "#fff",
                                fontSize: 10, fontWeight: 700,
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                                0
                            </Box>
                        </IconButton>

                        <Box
                            component="img"
                            src={userDetails?.profile_image || RohanImg}
                            onClick={(e: any) => setProfileMenuAnchor(e.currentTarget)}
                            sx={{
                                width: 36, height: 36, borderRadius: "50%", objectFit: "cover",
                                border: "2px solid rgba(255,255,255,0.1)", cursor: "pointer",
                            }}
                        />

                        <Menu
                            anchorEl={profileMenuAnchor}
                            open={isProfileMenuOpen}
                            onClose={() => setProfileMenuAnchor(null)}
                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                            PaperProps={{
                                sx: {
                                    mt: 1,
                                    background: "#0F1117",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                    borderRadius: "10px",
                                    minWidth: 200,
                                    color: "#fff",
                                    "& .MuiMenuItem-root": {
                                        fontSize: 13,
                                        py: 1, px: 1.5,
                                        "&:hover": { background: "rgba(255,255,255,0.06)" },
                                    },
                                    "& .MuiListItemIcon-root": {
                                        minWidth: 32, color: "rgba(255,255,255,0.65)",
                                    },
                                },
                            }}
                        >
                            <Box sx={{ px: 1.5, py: 1.2, borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
                                <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
                                    {userDetails?.first_name || "User"} {userDetails?.last_name || ""}
                                </Typography>
                                <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.5)", mt: 0.2 }}>
                                    {userDetails?.email || user_email}
                                </Typography>
                            </Box>

                            <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("profile"); }}>
                                <ListItemIcon><PersonOutlineOutlinedIcon sx={{ fontSize: 18 }} /></ListItemIcon>
                                Profile
                            </MenuItem>
                            <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("settings"); }}>
                                <ListItemIcon><SettingsOutlinedIcon sx={{ fontSize: 18 }} /></ListItemIcon>
                                Settings
                            </MenuItem>
                            <MenuItem onClick={() => { setProfileMenuAnchor(null); handleItemClick("billing"); }}>
                                <ListItemIcon><CreditCardOutlinedIcon sx={{ fontSize: 18 }} /></ListItemIcon>
                                Billing
                            </MenuItem>
                            <Divider sx={{ borderColor: "rgba(255,255,255,0.06)" }} />
                            <MenuItem
                                onClick={() => { setProfileMenuAnchor(null); handleItemClick("logout"); }}
                                sx={{ color: "#F87171 !important" }}
                            >
                                <ListItemIcon sx={{ "& svg": { color: "#F87171" } }}>
                                    <LogoutOutlinedIcon sx={{ fontSize: 18 }} />
                                </ListItemIcon>
                                Logout
                            </MenuItem>
                        </Menu>
                    </Stack>
                </Stack>

                {/* PAGE BODY */}
                <Box sx={{ p: { xs: 2, md: 3 } }}>

                    {/* ── LOADING OVERLAY ── */}
                    {isloadingGetPage && !getPageError && (
                        <Box sx={{
                            position: 'fixed', top: 0, left: 0,
                            width: '100%', height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 9999,
                            display: 'flex', justifyContent: 'center', alignItems: 'center',
                            backdropFilter: 'blur(5px)',
                        }}>
                            <Box sx={{
                                width: '80%', maxWidth: '700px', p: 2.5,
                                backgroundColor: '#282C39', borderRadius: '8px',
                                textAlign: 'center'
                            }}>
                                <Typography fontSize="30px">{loadingText}</Typography>
                                <Box mt={2}>
                                    <ProgressBar
                                        completed={loaderProgress}
                                        bgColor={loaderProgress >= 90 ? "#4CAF50" : "#4BA5EB"}
                                        height="20px" labelColor="#ffffff" labelAlignment="center"
                                    />
                                </Box>
                                <Typography fontSize="20px" mt={2}>
                                    Sit tight, your content monster AI Agents have got you covered…
                                </Typography>
                            </Box>
                        </Box>
                    )}

                    {/* ── PENDING PAYMENT BANNER ── */}
                    {planDetails?.payment_status === 'pending' && (
                        <Box sx={{
                            background: '#090619', borderRadius: '8px', p: 2, mb: 2,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                        }}>
                            <InfoIcon sx={{ color: 'orange', fontSize: 22 }} />
                            <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>
                                Subscription is PENDING — please complete the payment.
                            </Typography>
                        </Box>
                    )}

                    {/* ── PAGE HEADER CARD ── */}
                    <Box sx={{
                        background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        borderRadius: "16px",
                        p: 3,
                        mb: 3,
                    }}>
                        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between"
                            alignItems={{ xs: "flex-start", md: "center" }} spacing={2}>

                            <Stack direction="row" spacing={2} alignItems="center">
                                <Box sx={{
                                    width: 54, height: 54, borderRadius: "12px",
                                    background: "rgba(16,185,129,0.12)",
                                    border: "1px solid rgba(16,185,129,0.3)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}>
                                    <SchoolOutlinedIcon sx={{ color: "#10B981", fontSize: 28 }} />
                                </Box>
                                <Box>
                                    <Typography sx={{
                                        color: "#10B981", fontSize: 11, fontWeight: 700,
                                        letterSpacing: 1.2, textTransform: "uppercase",
                                    }}>
                                        COURSE
                                    </Typography>
                                    <Typography sx={{ fontSize: 26, fontWeight: 700, color: "#fff", lineHeight: 1.2 }}>
                                        Choose Your Course Topic
                                    </Typography>
                                    <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: 13.5, mt: 0.4 }}>
                                        Pick one of the AI-generated course topics below. Our AI will build a full course around it.
                                    </Typography>
                                </Box>
                            </Stack>

                            <Box sx={{
                                background: "rgba(16,185,129,0.08)",
                                border: "1px solid rgba(16,185,129,0.25)",
                                borderRadius: "12px",
                                px: 2, py: 1.2,
                                minWidth: 200,
                            }}>
                                <Stack direction="row" spacing={1} alignItems="center" mb={0.3}>
                                    <TrendingUpIcon sx={{ color: "#10B981", fontSize: 16 }} />
                                    <Typography sx={{ color: "#10B981", fontSize: 13, fontWeight: 700 }}>
                                        High Potential
                                    </Typography>
                                </Stack>
                                <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: 11.5 }}>
                                    Strong demand for these topics
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>

                    {/* ── SELECTION SECTION ── */}
                    <Box sx={{
                        background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        borderRadius: "16px",
                        p: 3,
                    }}>

                        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2.5}>
                            <Box>
                                <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>
                                    Personalized course suggestions
                                </Typography>
                                <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: 13, mt: 0.3 }}>
                                    Based on your expertise — pick the one you'd like us to create.
                                </Typography>
                            </Box>

                            <Button
                                startIcon={<RefreshIcon sx={{ fontSize: 16 }} />}
                                onClick={fetchCourseTopicSuggestions}
                                disabled={loadingtopics}
                                sx={{
                                    background: "linear-gradient(135deg,#7C3AED 0%, #9333EA 100%)",
                                    color: "#fff", borderRadius: "12px", px: 2.5, py: 1,
                                    textTransform: "none", fontWeight: 600, fontSize: 13,
                                    "&:hover": {
                                        opacity: 0.9,
                                        background: "linear-gradient(135deg,#7C3AED 0%, #9333EA 100%)",
                                    },
                                    "&.Mui-disabled": {
                                        background: "linear-gradient(135deg,#7C3AED 0%, #9333EA 100%)",
                                        opacity: 0.6, color: "#fff",
                                    },
                                }}>
                                {loadingtopics ? "Generating..." : "Regenerate"}
                            </Button>
                        </Stack>

                        {/* Course cards */}
                        <Stack spacing={2}>
                            {loadingtopics
                                ? Array.from({ length: 4 }).map((_, i) => (
                                    <Paper key={i} sx={{
                                        p: 3, borderRadius: "12px",
                                        background: "rgba(255,255,255,0.02)",
                                        border: "1px solid rgba(255,255,255,0.06)",
                                    }}>
                                        <Stack spacing={1}>
                                            <Skeleton variant="text" height={28} width="70%" sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
                                            <Skeleton variant="text" height={20} width="90%" sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
                                            <Skeleton variant="text" height={20} width="60%" sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
                                            <Stack direction="row" spacing={2} mt={2}>
                                                <Skeleton variant="rounded" height={36} width={140} sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
                                                <Skeleton variant="rounded" height={36} width={140} sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
                                                <Skeleton variant="rounded" height={36} width={140} sx={{ bgcolor: "rgba(255,255,255,0.05)" }} />
                                            </Stack>
                                        </Stack>
                                    </Paper>
                                ))
                                : COURSE_OPTIONS?.length === 0 ? (
                                    <Box sx={{
                                        p: 5, borderRadius: "12px",
                                        background: "rgba(255,255,255,0.02)",
                                        border: "1px dashed rgba(255,255,255,0.1)",
                                        textAlign: "center",
                                    }}>
                                        <SchoolOutlinedIcon sx={{ fontSize: 40, color: "rgba(255,255,255,0.25)", mb: 1 }} />
                                        <Typography color="rgba(255,255,255,0.6)" fontSize="14px" mb={0.5}>
                                            No course suggestions yet.
                                        </Typography>
                                        <Typography color="rgba(255,255,255,0.4)" fontSize="12.5px">
                                            Click "Regenerate" to try again.
                                        </Typography>
                                    </Box>
                                ) : COURSE_OPTIONS?.map((course: any, index: any) => {
                                    const checked = selectedCourses[0] === course.course_number;
                                    return (
                                        <Paper key={course.course_number} sx={{
                                            p: 3, borderRadius: "12px",
                                            background: checked
                                                ? "linear-gradient(135deg, rgba(75,165,235,0.08), rgba(75,165,235,0.02))"
                                                : "rgba(255,255,255,0.02)",
                                            border: checked
                                                ? "1px solid rgba(75,165,235,0.5)"
                                                : "1px solid rgba(255,255,255,0.06)",
                                            transition: "all 0.2s",
                                            cursor: savingtopicIndex === course.course_number ? "wait" : "pointer",
                                            "&:hover": {
                                                borderColor: checked ? "rgba(75,165,235,0.7)" : "rgba(255,255,255,0.15)",
                                            },
                                        }}
                                        onClick={() => {
                                            if (savingtopicIndex !== course.course_number) {
                                                toggleCourse(course.course_number);
                                            }
                                        }}
                                        >
                                            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={2}>
                                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                                    <TextField
                                                        value={course.title || course.name || ""}
                                                        onChange={(e) => handleCourseChange(index, "title", e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        variant="standard" fullWidth multiline
                                                        InputProps={{ disableUnderline: true }}
                                                        sx={{
                                                            "& .MuiInputBase-root": { padding: 0 },
                                                            "& .MuiInputBase-input": {
                                                                color: "#fff !important", fontSize: "17px",
                                                                lineHeight: "1.4", fontWeight: 700, padding: 0,
                                                            },
                                                            "& .MuiInputBase-inputMultiline": { padding: 0 },
                                                        }}
                                                    />
                                                    <TextField
                                                        value={course.description || ""}
                                                        onChange={(e) => handleCourseChange(index, "description", e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        variant="standard" fullWidth multiline
                                                        InputProps={{ disableUnderline: true }}
                                                        sx={{
                                                            mt: 0.75,
                                                            "& .MuiInputBase-root": { padding: 0 },
                                                            "& .MuiInputBase-input": {
                                                                color: "rgba(255,255,255,0.65)", fontSize: "13.5px",
                                                                lineHeight: "1.55", fontWeight: 400, padding: 0,
                                                            },
                                                            "& .MuiInputBase-inputMultiline": { padding: 0 },
                                                        }}
                                                    />
                                                </Box>

                                                <Box sx={{ width: 28, height: 28, position: "relative", flexShrink: 0 }}>
                                                    <Radio
                                                        checked={checked}
                                                        disabled={savingtopicIndex === course.course_number}
                                                        onChange={() => toggleCourse(course.course_number)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        sx={{
                                                            color: "rgba(255,255,255,0.35)",
                                                            "&.Mui-checked": { color: "#4BA5EB" },
                                                            padding: 0,
                                                            visibility: savingtopicIndex === course.course_number ? "hidden" : "visible",
                                                        }}
                                                    />
                                                    {savingtopicIndex === course.course_number && (
                                                        <CircularProgress size={22} sx={{
                                                            color: "#4BA5EB", position: "absolute", top: 0, left: 3,
                                                        }} />
                                                    )}
                                                </Box>
                                            </Stack>

                                            <Divider sx={{ mt: 2, borderColor: "rgba(255,255,255,0.06)" }} />

                                            <Stack direction="row" spacing={2} mt={2} flexWrap="wrap" useFlexGap>
                                                <Stack spacing={0.5} flex={1} minWidth={180}>
                                                    <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontWeight: 500 }}>
                                                        Target Audience
                                                    </Typography>
                                                    <TextField
                                                        value={course?.target_audience?.split(",")[0] || ""}
                                                        onChange={(e) => handleCourseChange(index, "target_audience", e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        size="small" fullWidth variant="outlined"
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                height: 36, borderRadius: "8px",
                                                                background: "rgba(255,255,255,0.04)",
                                                                border: "1px solid rgba(255,255,255,0.08)",
                                                                "& fieldset": { border: "none" },
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                color: "#fff !important", fontSize: "13px",
                                                                fontWeight: 500, padding: "8px 12px",
                                                            },
                                                        }}
                                                    />
                                                </Stack>

                                                <Stack spacing={0.5} flex={1} minWidth={180}>
                                                    <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontWeight: 500 }}>
                                                        Difficulty
                                                    </Typography>
                                                    <Select
                                                        value={course.difficulty || "Beginner"}
                                                        onChange={(e) => handleCourseChange(index, "difficulty", e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        sx={{
                                                            height: 36, borderRadius: "8px",
                                                            background: "rgba(255,255,255,0.04)",
                                                            border: "1px solid rgba(255,255,255,0.08)",
                                                            color: "#fff", fontSize: "13px", fontWeight: 500,
                                                            "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                                                            "& .MuiSelect-select": {
                                                                padding: "8px 12px",
                                                                display: "flex", alignItems: "center",
                                                            },
                                                            "& .MuiSelect-icon": { color: "rgba(255,255,255,0.5)" },
                                                        }}>
                                                        <MenuItem value="Beginner">Beginner</MenuItem>
                                                        <MenuItem value="Intermediate">Intermediate</MenuItem>
                                                        <MenuItem value="Expert">Expert</MenuItem>
                                                    </Select>
                                                </Stack>

                                                <Stack spacing={0.5} flex={1} minWidth={180}>
                                                    <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontWeight: 500 }}>
                                                        Suggested Price
                                                    </Typography>
                                                    <TextField
                                                        value={course.pricing || ""}
                                                        onChange={(e) => handleCourseChange(index, "pricing", e.target.value)}
                                                        onClick={(e) => e.stopPropagation()}
                                                        size="small" fullWidth variant="outlined"
                                                        sx={{
                                                            "& .MuiOutlinedInput-root": {
                                                                height: 36, borderRadius: "8px",
                                                                background: "rgba(255,255,255,0.04)",
                                                                border: "1px solid rgba(255,255,255,0.08)",
                                                                "& fieldset": { border: "none" },
                                                            },
                                                            "& .MuiOutlinedInput-input": {
                                                                color: "#fff !important", fontSize: "13px",
                                                                fontWeight: 500, padding: "8px 12px",
                                                            },
                                                        }}
                                                    />
                                                </Stack>

                                                <Stack spacing={0.5} flex={1} minWidth={180}>
                                                    <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.55)", fontWeight: 500 }}>
                                                        Duration
                                                    </Typography>
                                                    <Box sx={{
                                                        height: 36, borderRadius: "8px",
                                                        background: "rgba(255,255,255,0.04)",
                                                        border: "1px solid rgba(255,255,255,0.08)",
                                                        display: "flex", alignItems: "center", px: 1.5,
                                                    }}>
                                                        <Typography sx={{ color: "#fff", fontSize: 13, fontWeight: 500 }}>
                                                            {course.duration || "—"}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </Stack>
                                        </Paper>
                                    );
                                })}
                        </Stack>

                        {/* Action buttons */}
                        <Stack direction="row" justifyContent="flex-end" spacing={1.5} mt={3}>
                            <Button variant="outlined"
                                onClick={() => {
                                    localStorage.setItem('activeItem', 'blogs');
                                    navigate('/codegenie/generated-blogs');
                                }}
                                sx={{
                                    borderColor: "rgba(255,255,255,0.15)",
                                    color: "rgba(255,255,255,0.8)",
                                    textTransform: "none", borderRadius: "10px",
                                    px: 3, py: 1, fontSize: 13.5, fontWeight: 500,
                                    "&:hover": { borderColor: "rgba(255,255,255,0.3)", background: "rgba(255,255,255,0.04)" },
                                }}>
                                Close
                            </Button>

                            {FromSignUp && (
                                <Button variant="outlined"
                                    onClick={handleCreateCourseStepPrevious}
                                    sx={{
                                        borderColor: "rgba(255,255,255,0.15)",
                                        color: "rgba(255,255,255,0.8)",
                                        textTransform: "none", borderRadius: "10px",
                                        px: 3, py: 1, fontSize: 13.5, fontWeight: 500,
                                        "&:hover": { borderColor: "rgba(255,255,255,0.3)", background: "rgba(255,255,255,0.04)" },
                                    }}>
                                    Previous
                                </Button>
                            )}

                            <Button
                                disabled={!isCourseSelected}
                                onClick={handleCreateCourseStep2}
                                sx={{
                                    background: "linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)",
                                    color: "#fff", textTransform: "none", borderRadius: "10px",
                                    px: 3.5, py: 1, fontSize: 13.5, fontWeight: 600,
                                    "&:hover": { background: "linear-gradient(135deg, #6D28D9 0%, #5B21B6 100%)" },
                                    "&.Mui-disabled": {
                                        background: "rgba(255,255,255,0.06)",
                                        color: "rgba(255,255,255,0.3)",
                                    },
                                }}>
                                Next
                            </Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>

            {/* MODALS */}
            <Modal open={openpaymentInstructModal}>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    transform: "translate(-50%, -50%)",
                    width: isMobile ? "95%" : 600,
                    bgcolor: "background.paper", border: "2px solid #000",
                    boxShadow: 24, pt: 2, px: 4, pb: 3,
                }}>
                    <PriorityHighIcon style={{ color: 'yellow', fontSize: '38px' }} />
                    <p style={{ textAlign: 'center' }}>Please make a payment to complete your process.</p>
                    <Stack flexDirection="row">
                        <Button onClick={() => setOpenPaymentInstructModal(false)}
                            variant="contained" sx={{ mr: 2 }}>Pay Now</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={upgradeModal} disableEscapeKeyDown>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    transform: "translate(-50%, -50%)",
                    width: isMobile ? "95%" : "40%",
                    bgcolor: "background.paper", border: "2px solid #000",
                    boxShadow: 24, pt: 2, px: 4, pb: 3,
                    borderRadius: '15px', padding: '3%'
                }}>
                    <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        <InfoIcon sx={{ color: '#ffcc00' }} /><br />
                        This feature is not included in your plan. Please upgrade to access this feature.
                    </Typography>
                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>
                        <Button onClick={() => setUpgradeModal(false)} variant="contained">Close</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={helperPopup} disableEscapeKeyDown>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    transform: "translate(-50%, -50%)",
                    width: isMobile ? "95%" : "70%",
                    bgcolor: "background.paper", border: "2px solid #000",
                    boxShadow: 24, pt: 2, px: 4, pb: 3,
                    borderRadius: '15px', padding: '3%'
                }}>
                    <iframe width="100%" height="500" src={helpervideosrc}
                        title="Help Video" frameBorder="0"
                        allow="autoplay; encrypted-media" allowFullScreen />
                    <Stack flexDirection="row">
                        <Button onClick={() => setHelperPopup(false)}
                            variant="contained" sx={{ mr: 2, marginTop: '15%' }}>Close</Button>
                    </Stack>
                </Box>
            </Modal>
        </Box>

        <AIConciergePopup
            open={openAIConcierge}
            onClose={() => setOpenAIConcierge(false)}
            courseid={"6a155659b7d74efa94037f50"}
        />
        </>
    );
};

export default Course_Suggestions;